export const services = [
  {
    slug: "daily-cleaning",
    icon: "ri-building-4-line",
    title: "マンション日常清掃",
    subtitle: "共用部の毎日の美観を守る、基本にして最重要のサービス。",
    price: "¥〜／月",
    image:
      "images/building-cleaning.jpg",
    features: [
      "エントランス・共用廊下の掃き拭き",
      "郵便受け・エレベーター内の拭き上げ",
      "ゴミ置き場の整理と消臭",
      "植栽まわりの簡易清掃",
    ],
  },
  {
    slug: "periodic-cleaning",
    icon: "ri-brush-4-line",
    title: "定期清掃",
    subtitle: "月1〜隔月で行う、床材保護と美観維持のプロ施工。",
    price: "¥〜／回",
    image:
      "images/regular-cleaning.jpg",
    features: [
      "床面ポリッシャー洗浄・ワックス塗布",
      "エントランスガラス清掃",
      "手すり・巾木の除菌拭き",
      "高所ホコリ落とし",
    ],
  },
  {
    slug: "vacancy-cleaning",
    icon: "ri-home-smile-line",
    title: "原状回復",
    subtitle: "次の入居者様に自信を持って渡せる仕上がりへ。",
    price: "¥〜／戸",
    image:
      "images/house-repair.jpg",
    features: [
      "水回り徹底洗浄（キッチン・浴室・トイレ）",
      "エアコン外装清掃",
      "サッシ・網戸清掃",
      "内覧前チェックリスト付き",
    ],
  },
  {
    slug: "glass-cleaning",
    icon: "ri-window-line",
    title: "ガラス・サッシ清掃",
    subtitle: "第一印象を左右する透明感を、プロの技術で。",
    price: "¥〜／回",
    image:
      "images/glass-cleaning.jpg",
    features: [
      "エントランスガラス両面清掃",
      "サッシレール溝の砂ホコリ除去",
      "網戸取り外し洗浄",
      "高所窓は安全器具にて対応",
    ],
  },
  {
    slug: "house-cleaning",
    icon: "ri-sparkling-fill",
    title: "ハウスクリーニング",
    subtitle: "油汚れ・水垢・カビなど住まいの悩みを根本解決。",
    price: "¥〜／回",
    image:
      "images/house-cleaning.jpg",
    features: [
      "レンジフード・キッチンの油汚れ分解洗浄",
      "浴室・洗面・トイレの除菌水回り清掃",
      "エアコン内部のカビ除去・高圧洗浄",
      "退去後・入居前の全体重点清掃",
    ],
  },
  {
    slug: "spot-cleaning",
    icon: "ri-tools-line",
    title: "スポット・特殊清掃",
    subtitle: "落書き除去・水垢・カビなど、困った時のワンショット。",
    price: "¥〜／件",
    image:
      "images/spot-special.jpg",
    features: [
      "落書き・シール跡除去",
      "浴室カビ・水垢除去",
      "エアコン内部洗浄（別途）",
      "現地確認後お見積",
    ],
  },
];

export const strengths = [
  {
    icon: "ri-building-line",
    title: "不動産の知識で提案する",
    text: "20年の現場経験とオーナー視点。単なる清掃ではなく、資産価値を守る提案までワンストップで。",
  },
  {
    icon: "ri-flashlight-line",
    title: "地元だから初速が早い",
    text: "地域密着だから、最短即日で現地確認。急な退去やトラブルにもスピード対応します。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "低価格帯で対応する",
    text: "自社スタッフで対応、同等品質で他社より平均10%安い料金体系。",
  },
  {
    icon: "ri-shield-check-line",
    title: "丁寧・確実に報告をつける",
    text: "作業前後の写真報告。オーナー様が現地に行かなくても状況が一目でわかります。",
  },
];

export const stats = [
  { value: "20", suffix: "年", label: "業界実務経験" },
  { value: "70", suffix: "棟+", label: "累計管理物件" },
  { value: "98", suffix: "%", label: "契約継続率" },
  { value: "24", suffix: "h", label: "見積回答目標" },
];